import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {updateAnnotationAction} from '../../../src/util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function reviewNotesReducer(
	state = initialState.reviewNotes,
	action
) {
	switch (action.type) {
		case types.GET_REVIEWNOTE: {
			if (action.responseObj && action.responseObj.status == 200) {
				let taskReviewNote = action.response;
				taskReviewNote.notesLoaded = true;
				return taskReviewNote;
			} else {
				// error. in case of error scenario set annotations to empty object.
				// This is to avoid recurrive calls to API
				return {notesLoaded: true, annotations: [], error: true};
			}
		}
		case types.CLEAR_REVIEWNOTE:
			let newState = {};
			if (state) {
				newState.allOpenReviewNotesCount = state.allOpenReviewNotesCount;
				newState.myOpenReviewNotesCount = state.myOpenReviewNotesCount;
				newState.otherEngagementsReviewNoteCount =
					state.otherEngagementsReviewNoteCount;
				newState.isOtherEngagementsReviewNotePresent =
					state.isOtherEngagementsReviewNotePresent;
				newState.notesLoaded = undefined;
			}
			return newState;

		case types.DELETE_REVIEW_NOTE:
			let annotationsAfterRemove = [];
			let id = action.annotationId;
			state.annotations.map((annotation) => {
				if (annotation.id != id) {
					annotationsAfterRemove.push({
						...annotation
					});
				}
			});

			return {
				...state,
				annotations: annotationsAfterRemove
			};
		case types.UPDATE_SINGLE_REVIEW_NOTE_STATUS:
			let annotationId = action.data.id;
			var statusid = action.data.statusId;
			var annotations = state.annotations;

			annotations.map((annotation) => {
				if (annotation.id === annotationId) {
					var updateAnnotation = annotation;
					updateAnnotation.statusId = statusid;
					Object.assign({}, updateAnnotation);
				}
			});

			var reviewNote = {
				...action.response,
				annotations
			};

			return reviewNote;
		case types.Add_REVIEW_NOTE:
			console.log(action);
			if (
				action.payload &&
				action.payload.updateAction == updateAnnotationAction.replyNote
			) {
				let annotations = [...state.annotations];

				let updatedAnnotations = annotations.map((annotation) => {
					let updateAnnotation = {...annotation};
					if (updateAnnotation.id === action.payload.id) {
						if (!updateAnnotation.responses) {
							Object.assign(updateAnnotation, {responses: []});
						}
						let updatedResponses = [...updateAnnotation.responses];
						updatedResponses.push({
							text: action.payload.comments,
							id: action.response.id,
							createDate: action.response.createDate,
							createUserId: action.response.createUserId,
							createUserName: action.response.createUserName
						});
						updateAnnotation.responses = updatedResponses;
					}

					return updateAnnotation;
				});
				return {
					...state,
					annotations: updatedAnnotations
				};
			}
			return state;

		case types.SET_ANNOTATION_VALUE:
			return {...state, annotation: action.payload};
		default:
			return state;
	}
}
